export function SectionLabel({ children }: { readonly children: React.ReactNode }) {
  return (
    <span className="text-[11px] font-semibold text-ink-faint uppercase tracking-wider px-1">
      {children}
    </span>
  );
}

export function ToggleSwitch({
  checked,
  onChange,
}: {
  readonly checked: boolean;
  readonly onChange: () => void;
}) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      onClick={onChange}
      className={`relative shrink-0 inline-flex h-6 w-11 items-center rounded-full transition-colors ${
        checked ? "bg-accent" : "bg-ink-faint/30"
      }`}
    >
      <span
        className={`inline-block h-4 w-4 rounded-full bg-white shadow transition-transform ${
          checked ? "translate-x-6" : "translate-x-1"
        }`}
      />
    </button>
  );
}

export function ToggleRow({
  label,
  description,
  checked,
  onChange,
  badge,
}: {
  readonly label: string;
  readonly description?: string;
  readonly checked: boolean;
  readonly onChange: () => void;
  readonly badge?: string;
}) {
  return (
    <div className="flex items-center justify-between gap-3 py-2">
      <div className="flex flex-col gap-0.5 min-w-0">
        <div className="flex items-center gap-2">
          <span className="text-xs font-medium text-ink">{label}</span>
          {badge && (
            <span className="px-1.5 py-0.5 text-[10px] font-bold rounded bg-accent/15 text-accent leading-none">
              {badge}
            </span>
          )}
        </div>
        {description && (
          <span className="text-[11px] text-ink-muted leading-tight">{description}</span>
        )}
      </div>
      <ToggleSwitch checked={checked} onChange={onChange} />
    </div>
  );
}

export function NavRow({
  label,
  accent,
  onClick,
}: {
  readonly label: string;
  readonly accent?: boolean;
  readonly onClick: () => void;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`flex items-center justify-between w-full py-2.5 rounded-lg group ${
        accent
          ? "text-accent"
          : "text-ink-muted hover:text-ink"
      }`}
    >
      <span className="text-xs font-medium">{label}</span>
      <svg
        viewBox="0 0 24 24"
        className="w-4 h-4 opacity-40 group-hover:opacity-70 transition-opacity"
        stroke="currentColor"
        strokeWidth={2}
        fill="none"
      >
        <polyline points="9 18 15 12 9 6" />
      </svg>
    </button>
  );
}
